import { styled } from "@mui/material/styles";

export const StyledForm = styled("div")(({ theme }) => ({
    margin: "1%"
}));
